void import("./SvfWidget");

// oxlint-disable-next-line unicorn/require-module-specifiers
export {};
